import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue";
import _imports_0 from '../../assets/pic/MCT_Logo.png';
const _hoisted_1 = {
  class: "mct-header"
};
const _hoisted_2 = {
  class: "top-bar-quick-search"
};
const _hoisted_3 = {
  class: "top-bar-setting"
};
const _hoisted_4 = {
  class: "el-dropdown-link"
};
const _hoisted_5 = {
  class: "top-bar-user-img"
};
const _hoisted_6 = {
  class: "top-bar-user-info"
};
const _hoisted_7 = {
  class: "top-bar-user-name"
};
const _hoisted_8 = {
  class: "top-bar-user-time-zone"
};
import { ref, computed } from 'vue';
import { Star, SwitchButton, Search, ZoomIn } from '@element-plus/icons-vue';
import oauth from '@/utils/oauth';
// import { globalSearchApi } from '@/api/home/globalSearch'
// import MctSelectSearch from '@/components/MctSelectSearch.vue'
import PreferenceDialog from './preference-dialog.vue';
import SearchDialog from './search-dialog.vue';
import { storeToRefs } from 'pinia';
import { useUserDefaultSettingStore } from '@/store/user';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const userDefaultSettingStore = useUserDefaultSettingStore();
    const {
      timeZone,
      userName,
      privilege
    } = storeToRefs(userDefaultSettingStore);
    const searchOptions = [{
      label: 'Cluster',
      value: '0'
    }, {
      label: 'Zone',
      value: '3'
    }, {
      label: 'Check',
      value: '1'
    }, {
      label: 'URL',
      value: '2'
    }];
    const searchVal = ref('');
    const searchLevel = ref('0');
    const searchDialogVisible = ref(false);
    const searchValue = ref([]);
    const activeTab = ref('GLOBAL_SEARCH');
    const topBarQuickSearch = () => {
      searchValue.value = [searchLevel.value, searchVal.value];
      activeTab.value = 'GLOBAL_SEARCH';
      searchDialogVisible.value = true;
    };
    const handleBatchOperation = () => {
      searchValue.value = [searchLevel.value, searchVal.value];
      activeTab.value = 'BATCH_OPERATION';
      searchDialogVisible.value = true;
    };
    const preferenceDialogVisible = ref(false);
    const userNameAbbreviation = computed(() => {
      const nameList = userName.value.split(' ');
      const abbrList = nameList.map(name => name[0]);
      return abbrList.join('');
    });
    const privilegeMap = {
      0: 'View Only',
      100: 'Service Owner',
      200: 'Service Admin',
      255: 'Administrator'
    };
    const handleLogout = () => {
      oauth.logout();
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[9] || (_cache[9] = _createElementVNode("div", {
        class: "top-bar-title"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "MCT icon"
      }), _createElementVNode("span", null, "MCT")], -1)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
        onKeyup: _withKeys(topBarQuickSearch, ["enter"]),
        modelValue: searchVal.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchVal.value = $event),
        placeholder: "Hostname/IP/Subnet",
        class: "select-search no-border"
      }, {
        prepend: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: searchLevel.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchLevel.value = $event),
          placeholder: "Cluster",
          style: {
            width: '90px'
          }
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(searchOptions, option => {
            return _createVNode(_component_el_option, {
              key: option.label,
              label: option.label,
              value: option.value
            }, null, 8, ["label", "value"]);
          }), 64))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_button, {
        class: "ml-5",
        type: "primary",
        icon: _unref(Search),
        round: "",
        onClick: topBarQuickSearch
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode(" Search ")])),
        _: 1
      }, 8, ["icon"]), _createVNode(_component_el_button, {
        class: "ml-5",
        type: "primary",
        icon: _unref(ZoomIn),
        round: "",
        onClick: handleBatchOperation
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode(" Advanced ")])),
        _: 1
      }, 8, ["icon"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_dropdown, null, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            command: "preference"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              icon: _unref(Star),
              text: "",
              onClick: _cache[2] || (_cache[2] = $event => preferenceDialogVisible.value = true)
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode(" Preferences ")])),
              _: 1
            }, 8, ["icon"])]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            command: "e",
            divided: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              icon: _unref(SwitchButton),
              onClick: handleLogout,
              text: ""
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode(" Log Out ")])),
              _: 1
            }, 8, ["icon"])]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(userNameAbbreviation.value), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(_unref(userName)), 1), _createElementVNode("span", _hoisted_8, " (" + _toDisplayString(privilegeMap[_unref(privilege)]) + ") " + _toDisplayString(Number(_unref(timeZone)) >= 0 ? `UTC+${_unref(timeZone)}` : `UTC${_unref(timeZone)}`), 1)])])]),
        _: 1
      })]), _createVNode(PreferenceDialog, {
        visible: preferenceDialogVisible.value,
        "onUpdate:visible": _cache[3] || (_cache[3] = $event => preferenceDialogVisible.value = $event),
        visibleModifiers: {
          sync: true
        }
      }, null, 8, ["visible"]), _createVNode(SearchDialog, {
        visible: searchDialogVisible.value,
        "onUpdate:visible": _cache[4] || (_cache[4] = $event => searchDialogVisible.value = $event),
        visibleModifiers: {
          sync: true
        },
        "active-tab": activeTab.value,
        "search-value": searchValue.value
      }, null, 8, ["visible", "active-tab", "search-value"])]);
    };
  }
});